import BugReport from "../forms/BugReport";
import { userEmail } from "../../stores/userStore";
import DeleteAccount from "./DeleteAccount";
import { createSignal } from "solid-js";

export default function Settings() {
  const email = userEmail();
  const [showDelete, setShowDelete] = createSignal(false);

  return (
    <div>
      <BugReport email={email}></BugReport>
      <button class="button1" onClick={() => setShowDelete(true)}>
        Delete Account
      </button>
      {showDelete() ? (
        <div class="settings-modal-overlay">
          <div class="settings-modal">
            <DeleteAccount email={email} exit={setShowDelete}></DeleteAccount>
          </div>
        </div>
      ) : null}
    </div>
  );
}
